import React from 'react'
import { Link } from 'react-router-dom'

export interface IFirstLevelItem {
  id: string
  name: string
  pathname: string
  className?: string
}
interface IProps {
  firstLevelLinks: IFirstLevelItem[]
  activeFirstLevelId: string
  setActiveFirstLevelId(id: string): void
}

const MenuFirstLevel: React.FC<IProps> = ({ firstLevelLinks, activeFirstLevelId, setActiveFirstLevelId }) => {
  return (
    <>
      {firstLevelLinks.map((item, idx) => {
        return (
          <li
            key={item.id}
            className={`MenLv1 ${activeFirstLevelId === item.id ? 'active' : ''} ${item.className || ''}`}
            onMouseEnter={() => {
              setActiveFirstLevelId(item.id)
            }}
          >
            <Link
              aria-label={item.name}
              to={item.pathname}
              onClick={() => {
                setActiveFirstLevelId(null)
              }}
            >
              <span className={item.className}>{item.name}</span>
            </Link>
          </li>
        )
      })}
    </>
  )
}

export default React.memo(MenuFirstLevel)
